import { LookupTableState } from "../../models/states/LookupTableState";
import { ActionTypes } from "../actions/types";
import { LOOKUP_TABLE_FETCH, LOOKUP_TABLE_RECEIVE } from "../actions";

const INITIAL_STATE: LookupTableState = {
    lookupTable: {},
    requestId: {},
    tableName: "",
};

const randomId = () => Math.random().toString(36).substr(2, 10);

export const lookupTableReducer = (state = INITIAL_STATE, action: ActionTypes) => {
    switch (action.type) {
        case LOOKUP_TABLE_FETCH:
            return {
                ...state,
                questionName: action.questionName,
                requestId: {
                    ...state.requestId,
                    [action.questionName]: randomId(),
                },
            };
        case LOOKUP_TABLE_RECEIVE:
            if (state.requestId[action.questionName] !== action.requestId) {
                return state;
            }
            return {
                ...state,
                lookupTable: {
                    ...state.lookupTable,
                    [action.questionName]: action.page,
                },
            };
        default:
            return state;
    }
};
